module.exports = __webpack_public_path__ + "static/media/add-scenario.e638962c.svg";